<template>
  <hgroup :class="classes">
    <typography-title
      class="cordel-typography-heading-title"
      :hierarchy="hierarchy"
    >
      <slot />

      <font-awesome-icon
        v-if="icon"
        class="cordel-typography-heading-icon"
        icon="chevron-right"
      />
    </typography-title>

    <typography-subtitle
      v-if="$slots.subtitle"
      class="cordel-typography-heading-subtitle"
      :hierarchy="hierarchy"
    >
      <slot name="subtitle" />
    </typography-subtitle>
  </hgroup>
</template>

<script>
  import TypographyTitle from '@cordel/components/Typography/Title.vue';
  import TypographySubtitle from '@cordel/components/Typography/Subtitle.vue';

  export default {
    name: 'CordelTypographyHeading',
    components: {
      TypographyTitle,
      TypographySubtitle,
    },
    props: {
      hierarchy: {
        type: String,
        default: undefined,
      },
      icon: {
        type: String,
        default: null,
      },
      bold: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      classes() {
        const classes = ['cordel-typography-heading'];

        if (this.icon) {
          classes.push('variant--iconed');
        }

        if (this.bold) {
          classes.push('variant--bold');
        }

        return classes;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-typography-heading {
  }

  .cordel-typography-heading-title {
    .variant--iconed & {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .cordel-typography-heading-subtitle {
    .variant--bold & {
      font-weight: var(--cordel-font-weight-bold);
    }
  }

  .cordel-typography-heading-icon {
    margin-left: var(--cordel-spacing-s);
  }
</style>
